import React, { useState, useEffect, useMemo, useCallback } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { FormCustom, Input, Select } from '../../Components/Form/Form';
import Button from 'react-bootstrap/Button'
import Loading from '../../Components/Layout/Styled/Loading'

const BreakBoxBranchOffice = _ => {
    const [branchOffices, setBranchOffices] = useState([])
    const [reporte, setReport] = useState({})

    useEffect(() => {
        Controllers.branch_office.get_branch_office().then(res => {
            setBranchOffices(res.data)
        })
    }, [])

    const [data, setData] = useState({
        p_id_branch_office: '',
        p_date_start: '',
        p_date_end: ''
    })
    const [showLoading, setShowLoading] = useState(false)

    const branchOffice = useCallback(() => {
        if (!data.p_id_branch_office) {
            return ''
        }

        let findBranchOffice = branchOffices.find(w => parseInt(w.id_branch_office) === parseInt(data.p_id_branch_office))

        if (!findBranchOffice) {
            return ''
        }

        return {
            label: findBranchOffice.name_branch_office,
            value: findBranchOffice.id_branch_office
        }
    }, [data.p_id_branch_office, branchOffices])

    return <div className="ui-page">
        <div className="ui-page-head">
            <div>
                <h1 className="ui-page-title">Corte de Caja por Sucursal</h1>
                <p className="ui-page-meta">Genera PDF o Excel por rango de fechas</p>
            </div>
        </div>
        <Card className="ui-list-shell border-0">
            <Card.Header>
                <span>Parámetros</span>
            </Card.Header>
            <Card.Body>
                <div className="ui-report-filters">
                <FormCustom viewSubmit={false} onSubmit={_ => {
                    if (!data.p_id_branch_office) {
                        Helpers.toast.construct({
                            response: 'warning',
                            message: 'Seleccionar Sucursal',
                            toast
                        })
                        return
                    }

                    setShowLoading(true)
                    setReport({})
                    Controllers.report.get_break_box_branch_office(data).then(res => {
                        if (res.response !== 'success') {
                            Helpers.toast.construct({ ...res, toast })
                            return
                        }

                        setReport({
                            pdf: res.data.pdf.file,
                            excel: res.data.excel.file,
                            filename: res.data.filename,
                        })
                    }).catch(req => Helpers.promise.catch({ req, toast }))
                        .finally(() => {
                            setShowLoading(false)
                        })
                }}>
                    <Select
                        classNameParent="col-12 mb-2"
                        icon="fa fa-user"
                        text="Usuario"
                        required
                        onChange={e => {
                            setReport({})
                            setData({ ...data, p_id_branch_office: e.value })
                        }}
                        value={branchOffice()}
                        options={branchOffices.map(w => {
                            return {
                                label: w.name_branch_office,
                                value: w.id_branch_office
                            }
                        })}
                    />
                    <Input
                        classNameParent="col-6 mb-4"
                        type="date"
                        icon="far fa-calendar-alt"
                        placeholder="Fecha Inicio"
                        text="Fecha Inicio"
                        required
                        value={data.p_date_start}
                        onChange={e => {
                            setReport({})
                            setData({ ...data, p_date_start: e.currentTarget.value })
                        }}
                    />
                    <Input
                        classNameParent="col-6 mb-4"
                        type="date"
                        icon="far fa-calendar-alt"
                        placeholder="Fecha Fin"
                        text="Fecha Fin"
                        required
                        value={data.p_date_end}
                        onChange={e => {
                            setReport({})
                            setData({ ...data, p_date_end: e.currentTarget.value })
                        }}
                        append={[
                            <Button type="submit">
                                <i className="fa fa-search"></i>
                            </Button>
                        ]}
                    />
                </FormCustom>
                </div>
                <div className="ui-report-result">
                {reporte?.filename ? <>
                    <p className="ui-form-section-title">Descargas</p>
                    <a href={reporte?.pdf} className="mr-2" download={reporte?.filename}>
                        <Button size="sm" variant="danger">
                            <i className="fa fa-file-pdf mr-2"></i>Descargar Reporte PDF
                        </Button>
                    </a>
                    <a href={reporte?.excel} download={reporte?.filename}>
                        <Button size="sm" variant="success">
                            <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                        </Button>
                    </a>
                </> : <div className="ui-empty-hint">Completa los filtros para generar el corte.</div>}
                </div>
            </Card.Body>
        </Card>
        <Loading show={showLoading}>
            <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
        </Loading>
    </div>
}

export default BreakBoxBranchOffice